<template>
    <div class="bg-white p-6 rounded-lg shadow-lg">
        <h3 class="text-lg font-semibold text-gray-800 mb-4 flex items-center">
            <span class="mr-2">👥</span> Students per Course Code (Top 10)
        </h3>
        <div>
            <apexchart type="bar" height="400" :options="barOptions" :series="barSeries"
                @dataPointSelection="handleBarClick" />
        </div>

        <!-- Others Course Codes Modal -->
        <base-modal v-if="showOthersModal" title="Other Students per Course Code" height=""
            @close="showOthersModal = false">
            <div class="overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-100 sticky top-0 z-10">
                        <tr>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                #
                            </th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Course Code
                            </th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                                Total Students
                            </th>
                        </tr>
                    </thead>
                    <tbody class="bg-white divide-y divide-gray-100">
                        <tr v-for="(course, index) in otherCourseCodesData" :key="index"
                            class="hover:bg-gray-50 transition-colors">
                            <td class="px-6 py-4 text-sm text-gray-500">{{ index + 1 }}</td>
                            <td class="px-6 py-4 text-sm text-gray-900 font-medium">{{ course.course_code }}</td>
                            <td class="px-6 py-4 text-sm text-gray-800 text-center font-medium">
                                {{ course.total_students }}
                            </td>
                        </tr>
                    </tbody>
                    <tfoot class="bg-gray-50 font-semibold">
                        <tr>
                            <td class="px-6 py-3 text-center text-gray-700" colspan="2">Total</td>
                            <td class="px-6 py-3 text-center text-gray-900">{{ totalStudents }}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </base-modal>
    </div>
</template>

<script>
export default {
    name: "TopStudentsChart",
    props: {
        data: {
            type: Array,
            required: true
        },
        powerBiColors: {
            type: Array,
            required: true
        },
        fetchOtherCourseCodes: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            showOthersModal: false,
            otherCourseCodesData: []
        };
    },
    computed: {
        barOptions() {
            const labels = this.data.map(item => item.course_code);

            return {
                chart: {
                    type: 'bar',
                    toolbar: {
                        show: false
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: '55%',
                        endingShape: 'rounded',
                        distributed: true
                    }
                },
                dataLabels: {
                    enabled: true,
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: labels,
                    labels: {
                        style: {
                            fontSize: '12px'
                        }
                    },
                    title: {
                        text: 'No of Students'
                    },
                },
                fill: {
                    opacity: 1,
                    colors: this.powerBiColors.slice(0, labels.length)
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " students"
                        }
                    }
                },
                legend: {
                    formatter: function (val, opts) {
                        return val + " - " + opts.w.globals.series[0][opts.seriesIndex];
                    },
                    position: "right",
                },
                colors: this.powerBiColors.slice(0, labels.length),
                responsive: [
                    {
                        breakpoint: 640,
                        options: {
                            legend: {
                                position: 'bottom',
                            }
                        }
                    },
                ]
            };
        },
        barSeries() {
            return [{
                name: 'Total Students',
                data: this.data.map(item => item.total_students)
            }];
        },
        totalStudents() {
            return this.otherCourseCodesData.reduce((sum, course) => sum + (course.total_students || 0), 0);
        }
    },
    methods: {
        async handleBarClick(event, chartContext, config) {
            const courseCode = config.w.config.xaxis.categories[config.dataPointIndex];

            if (courseCode === 'Others') {
                try {
                    const response = await this.fetchOtherCourseCodes();
                    if (response && response.course_codes) {
                        this.otherCourseCodesData = response.course_codes;
                        this.showOthersModal = true;
                    } else {
                        this.otherCourseCodesData = [];
                    }
                } catch (error) {
                    console.error('Error fetching other course codes:', error);
                    this.otherCourseCodesData = [];
                }
            }
        }
    }
};
</script>

<style scoped>
/* Additional styling if needed */
</style>
